import React from "react";
import { Grid } from "@mui/material";
import BottomLinks from "../BottomLinks";
import Footer from "../Footer";
import PostSingle from "../PostSingle";

export default function Heidegger02() {
  return (
    window.scrollTo(0, 0),
    (
      <div>
        <Grid container>
          <Grid item xs={0} sm={0} md={1}></Grid>
          <Grid item xs={12} sm={12} md={10}>
            <PostSingle props={data} />
            <BottomLinks />
          </Grid>
        </Grid>

        <Footer />
      </div>
    )
  );
}

const data = {
  image:
    "https://images.freeimages.com/images/small-previews/d2f/bluebells-2007-1374105.jpg",
  title: (
    <>
      تفاوت انتولوژیک
      <br />
      Ontologische Differenz
    </>
  ),
  text: (
    <p>
      از مهم‌ترین ویژگی‌های فلسفه‌ی هایدگر که اندیشه‌ی او را از سنتِ فلسفی و
      متافیزیک مدرن متمایز کرده و در فهمشِ اندیشه‌ی وی بسیار راه‌گشاست، ایده‌ی
      «تفاوت انتولوژیک» است. در سنتِ فلسفی، وظیفه‌ی اصلیِ هر اُنتولوژی
      (هستی‌شناسی)، برپاسازیِ کلیِ یک نظامِ سرشت‌شناسی Wesenslehre است. نظامی که
      تلاش می‌کند به ماهیت و هستیِ چیزها بپردازد (LPB - 310). در بسیاری از این
      اُنتولوژی‌ها، یا هستی Sein و هستنده Seiende هم‌سنگ پنداشته شده‌اند و جنسِ
      پرداختن به مساله‌ی هستی بسیار نزدیک به جنسِ پرداختن به مساله‌ی هستنده بوده
      است. و یا بیش از آن‌که به هستی پرداخته شود، به هستنده پرداخته شده است و
      مساله‌ی هستی، به دست فراموشی سپرده شده است. وضعیتی که هایدگر آن را
      فراموشیِ هستی Seinsvergessenheit می‌نامد.
      <p></p>
      برای روشن شدنِ موضوعِ پرسش از معنای هستی و اصلاح سنتِ فلسفی که معنای
      هستنده و هستی را درهم‌آمیخت‌ و هم‌سنگ پنداشت‌، و یا هستنده را بر هستی
      مقدّم دانست، هایدگر می‌کوشد تا به شکلی بنیادین، این دو مفهوم را از یکدیگر
      جدا کرده و آنها را بازتعریف کند: اُنتیک در برابر اُنتولوژیک. هستنده در
      برابر هستی:
      <p></p>
      اُنتیک Ontisch معطوف به هستنده است. هستنده‌ای که می‌اندیشد، سخن می‌گوید،
      می‌زیید و می‌میرد. اُنتیک همان پژوهش درباره‌ی خودِ هستنده است. پژوهشی
      درباره‌ی «بیرونِ چیزها». اُنتیک در ساحتِ عملی و واقعی faktisch قابلِ فهم
      است.
      <p></p>
      اُنتولوژیک Ontologisch به ‌معنای هستی و «فهمشِ هستی» ست. فهمشِ هستی و نیز
      امکانِ فهمشِ هستی. امکانِ اندیشیدن درباره‌ی هستی و هستی‌مندی: پرداختن به
      هستیِ چیزها «از درون». اُنتولوژیک در ساحتِ نظری و فلسفی‌ جریان دارد.
      <p></p>
      <b>کارکرد تفاوت انتولوژیک</b>
      <br />
      گفتیم که سنتِ فلسفی، این‌جا و آن‌جا، هستی Sein را هستنده‌ای در میانِ دیگر
      هستنده‌ها می‌پنداشت و از این روی پرسشِ نادرستِ «هستی چیست» را طرح می‌ریخت،
      تو گویی به همان‌گونه که می‌توان به چیستیِ هستنده Seiende پرداخت (به‌طور
      مثال آن‌گونه که علم به چیستیِ اجزا طبیعت می‌پردازد)، همان‌گونه نیز امکانِ
      پرداختن به چیستیِ هستی فراهم است. علاوه بر آن، نگاه سنت فلسفی به هستی،
      نوعی نگاهِ کلیّ‌نگر و تمامیّت‌گرا بود. کلیّتی فراسویِ خودِ چیزها. هایدگر
      به وضوح در برابر این نوع فهمشِ کلّی یا شئ‌انگارِ هستی یعنی پرسش از
      «چیستیِ» هستی صف‌آرایی کرده و بر این باور است که می‌بایستی درباره‌ی
      «معنایِ» هستی، و نه «چیستیِ» هستی پرسش نمود، چرا که «چیستی»، قابلِ اطلاق
      به «شئ» است و از آن‌جا که هستی «شئ» نیست، پرسش از چیستیِ هستی نیز از
      بنیان، پرسشی نادرست است. هایدگر استدلال خود را بر پایه‌‌ی تفاوت انتولوژیک
      بنا می‌دهد. حال با بهره گیری از تمایزِ میانِ هستی و هستنده، طرح دو نکته
      لازم می‌آید: نخست آن‌که هستی به تنهایی و به طور مستقل قابل دسترسی نیست.
      آن‌چه در دسترس است، هستنده است و نه هستی. هرچه به سمت هستی می‌رویم و به
      سوی او چنگ می‌ساییم، بیشتر از آن دور می‌شویم. تنها «چیزی» که بدان نزدیک
      می‌شویم، هستنده است، و نه هستی (SZ -§3). دوم: با وجود آن‌که هستی هماره از
      طریقِ یک هستنده فهمیده می‌شود، اما قابلِ فروکاهش به یک هستنده نیست. هستیِ
      هستنده، خود، یک هستنده نیست (SZ - §2). به بیانِ دیگر، هستی، نه یک هستنده
      در میانِ دیگر هستنده‌هاست (SZ - §2) که امکان پرسش از «چیستیِ» آن فراهم
      باشد. و نه ویژگی‌های یک هستنده برای آن قابلِ تصّور است. هستی به مثابه
      موضوعِ پرسش، و «معنا»ی هستی به مثابه آن‌چه موردِ نظرِ نهایی و مقصدِ
      پایانیِ پرسش است، هیچ‌ یک سرشتی اُنتیک نداشته و دارای ویژگی‌های یک هستنده
      نیست‌اند. هستی و معنای هستی، هر دو نهادی اُنتولوژیک‌اند. نهادی که اگر تلاش
      شود با ابزار جهان اُنتیک سنجش شود (یعنی به عنوان یک شئ، درباره‌ی چیستیِ
      کلّیِ آن پژوهش شود)، ما را از سرآغازِ اندیشیدن، هم‌چون بسیاری از
      اندیشمندانِ سنتِ فلسفی، به خطا خواهد برد. در نتیجه از آ‌ن‌جا که هستی، خود،
      یک هستنده نیست، هستیِ هستنده نیز، یک هستنده به‌شمار نخواهد آمد و بایستی در
      جهانی اُنتولوژیک اندیشه شود.
      <p></p>
      اما این‌که می‌گوییم «هستیِ هستنده، خود، یک هستنده نیست» دقیقا به چه
      معناست؟ هایدگر با طرح مفهومِ «تفاوت انتولوژیک» کوشید تا هستنده (اُنتیک) را
      از هستی (اُنتولوژیک) تمیز داده و خطی روشن میانِ هستی Sein و هستنده Seiende
      ترسیم کند. از این طریق، راه بر تمامیِ انگاشت‌های پیشینی که «جنس» هستی و
      هستنده را یکسان می‌پنداشتند بسته شد. او نه از چیستیِ هستی که از معنایِ
      هستی پرسش می‌کند. پرسش از هستی نه به عنوانِ یک کلیّت و تمامیّت، که به
      عنوانِ چیزی جزئی و وابسته به هستنده. با جداسازیِ بنیادینِ هستی و هستنده،
      امکانِ بازتعریف آن فراهم می‌شود: نباید هستی را هم‌چون هستنده، به عنوانِ یک
      «چیز، شی، Ding» اندیشه کرد. پس اگر هستی، یک هستنده نیست، چه‌گونه باید
      «جنس» آن را فهمش و تجسّم کنیم؟ هایدگر پاسخ می‌دهد: جنسِ هستی «زمان» است و
      جنسِ هستنده «شئ»: زمانی‌یّت در برابر شي‌یّت.
    </p>
  ),
};
